import React, { useState } from "react";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Select, Checkbox } from "antd";
import { useCustom } from "@refinedev/core";
import { CREATE_MINUTE_TEMPLATE_MUTATION } from "./queries";
import { DOCUMENT_TEMPLATE_LIST_QUERY } from "../document-template/queries";
import { IMinuteTemplate } from "./interface";

const { Option } = Select;

export const MinuteTemplateCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<IMinuteTemplate>({
    resource: "minuteTemplates",
    meta: {
      gqlMutation: CREATE_MINUTE_TEMPLATE_MUTATION,
    },
  });

  const [contentType, setContentType] = useState<string>("RAW_CONTENT");

  // Fetch document templates
  const { data: documentTemplatesData, isLoading: documentTemplatesLoading } = useCustom({
    url: "",
    method: "get",
    meta: {
      gqlQuery: DOCUMENT_TEMPLATE_LIST_QUERY,
    },
  });



  const handleContentTypeChange = (value: string) => {
    setContentType(value);
  };

  return (
    <Create saveButtonProps={saveButtonProps} title="Create Minute Template">
      <Form layout="vertical" {...formProps}>
        <Form.Item
          label="Template Name"
          name="name"
          rules={[{ required: true, message: "Please enter template name" }]}
        >
          <Input placeholder="Enter template name" />
        </Form.Item>

        <Form.Item
          label="Minute Type"
          name="minuteType"
          rules={[{ required: true, message: "Please select minute type" }]}
        >
          <Select placeholder="Select minute type" style={{ width: "100%" }}>
            <Option value="BID_OPENING">Bid Opening</Option>
            <Option value="EVALUATION_AWARD">Evaluation and Award</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Content Type"
          name="contentType"
          rules={[{ required: true, message: "Please select content type" }]}
        >
          <Select 
            placeholder="Select content type" 
            style={{ width: "100%" }}
            value={contentType}
            onChange={handleContentTypeChange}
          >
            <Option value="RAW_CONTENT">Raw Content (Mustache Template)</Option>
            <Option value="DOCUMENT_TEMPLATE">Document Template (DOCX)</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Version"
          name="version"
          rules={[{ required: true, message: "Please enter version" }]}
        >
          <Input placeholder="Enter version (e.g., 1.0)" />
        </Form.Item>

        {contentType === "RAW_CONTENT" && (
          <Form.Item
            label="Content (Mustache Template)"
            name="content"
            rules={[{ required: true, message: "Please enter template content" }]}
          >
            <Input.TextArea 
              placeholder="Enter Mustache template content" 
              rows={10}
              style={{ fontFamily: "monospace" }}
            />
          </Form.Item>
        )}
       

        <Form.Item
          label={
            contentType === "DOCUMENT_TEMPLATE"
              ? "Document Template (Required)"
              : "Reference Document (Optional)"
          }
          name="documentTemplateId"
          rules={[
            {
              required: contentType === "DOCUMENT_TEMPLATE",
              message:
                contentType === "DOCUMENT_TEMPLATE"
                  ? "Please select document template"
                  : undefined,
            },
          ]}
          help={
            contentType === "DOCUMENT_TEMPLATE"
              ? "This document template will be used for Carbone rendering with the template data."
              : "Optional: Select a reference document for Pandoc conversion (used for styles, headers, and footers)."
          }
        >
          <Select
            placeholder={
              contentType === "DOCUMENT_TEMPLATE"
                ? "Select document template"
                : "Select reference document (optional)"
            }
            style={{ width: "100%" }}
            loading={documentTemplatesLoading}
            allowClear={contentType === "RAW_CONTENT"}
          >
            {documentTemplatesData?.data?.documentTemplates?.nodes.map(
              (template: any) => (
                <Option key={template.id} value={template.id}>
                  {template.documentName} ({template.category} - {template.tag})
                </Option>
              )
            )}
          </Select>
        </Form.Item>

        <Form.Item
          label="Venue"
          name="venue"
          rules={[{ required: true, message: "Please enter venue" }]}
        >
          <Input placeholder="Enter venue" />
        </Form.Item>

        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Checkbox>Active</Checkbox>
        </Form.Item>
      </Form>
    </Create>
  );
};
